var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvascontainer",staticClass:"canvas-container-animation-spine-seasonpass-unlock-level",style:({ opacity: _vm.containerOpacity }),attrs:{"id":"canvas-container-animation-spine-seasonpass-unlock-level"}})}
var staticRenderFns = []

export { render, staticRenderFns }